import { render, staticRenderFns } from "./AccountingSettings.vue?vue&type=template&id=48f7ab60&"
import script from "./AccountingSettings.vue?vue&type=script&lang=js&"
export * from "./AccountingSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QSelect,QItem,QItemSection,QToggle} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSelect,QItem,QItemSection,QToggle})
